"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consoleReplay = consoleReplay;
exports["default"] = buildConsoleReplay;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _RenderUtils = _interopRequireDefault(require("./RenderUtils"));

var _scriptSanitizedVal = _interopRequireDefault(require("./scriptSanitizedVal"));

function consoleReplay() {
  // console.history is a global polyfill used in server rendering.
  // $FlowFixMe
  if (!(console.history instanceof Array)) {
    return '';
  }

  var lines = console.history.map(function (msg) {
    var stringifiedList = msg.arguments.map(function (arg) {
      var val;

      try {
        val = typeof arg === 'string' || arg instanceof String ? arg : (0, _stringify["default"])(arg);
      } catch (e) {
        val = "".concat(e.message, ": ").concat(arg);
      }

      return (0, _scriptSanitizedVal["default"])(val);
    });
    return "console.".concat(msg.level, ".apply(console, ").concat((0, _stringify["default"])(stringifiedList), ");");
  });
  return lines.join('\n');
}

function buildConsoleReplay() {
  return _RenderUtils["default"].wrapInScriptTags('consoleReplayLog', consoleReplay());
}